export default {
  dashboard: 'Dashboard',

  'dashboard.totalWorkOrderAverageTicket': 'Total Ticket Médio (Orçamento)',
  'dashboard.monthlyTotalWorkOrderAverageTicket':
    'Total Ticket Médio Mês (Orçamento)',
  'dashboard.monthlyTotalWorkOrderAverageRealTicket':
    'Total Ticket médio real (Orçamento)',
  'dashboard.monthlyDeliveries': 'Entregas para Agosto',
  'dashboard.delayedDeliveries': 'Entregas em Atraso',

  'dashboard.partsAndServicesReport': 'Relatório de Peças e Serviços',
  'dashboard.partsAndServicesReport.partsAndServicesTotal':
    'Total de Peças/Serviços (R$)',

  'dashboard.financialReport': 'Relatório Financeiro',
  'dashboard.financialReport.incomeAndExpensesRelation':
    'Relação entre Receitas/Despesas (R$)',

  'dashboard.averageTicketReport': 'Relatório de Ticket Médio',
  'dashboard.averageTicketReport.averageTicketPartsAndServices':
    'Ticket Médio (Peças x Serviços) (R$)',

  'dashboard.lastSixMonths': 'Período: Últimos seis meses',

  'dashboard.team': 'Equipe',

  'dashboard.averageTicket.modal.form.startDate.endDate': 'Data início/Fim',
  'dashboard.averageTicket.modal.form.types': 'Tipos',
  'dashboard.averageTicket.modal.form.courtesy': 'Cortesia',
  'dashboard.averageTicket.modal.form.insideCourtesy': 'Interna (Cortesia)',
  'dashboard.averageTicket.modal.form.warranty': 'Garantia',
  'dashboard.averageTicket.modal.form.work_order': 'Ordem de Serviço',
  'dashboard.averageTicket.modal.form.total_loss': 'Perda Total',
  'dashboard.averageTicket.modal.form.return': 'Retorno',
  'dashboard.averageTicket.modal.form.revision': 'Revisão',
  'dashboard.averageTicket.modal.form.companies': 'Empresas',
};
